import React, { forwardRef } from "react";
import { makeStyles } from "@material-ui/core";
import BarChart from "components/D3Charts/BarChart";
import PieChart from "components/D3Charts/PieChart";
import LineChart from "components/EMEA/EMEA_Charts/LineChart";
import TrendLineChart from "components/EMEA/EMEA_Charts/TrendLineChart";

const useStyles = makeStyles(theme => ({
    root: ({ chartType, axisLabelLength }) => ({
        padding: theme.spacing(0, 1, 1),
        color: theme?.palette?.black,
        boxShadow: '0 0 5px 0 rgba(0,0,0,0.3)',
        width: '100%',
        // width: chartType == 'pie' ? `${400 + axisLabelLength * 10}px` : '100%',
        // marginLeft: chartType == 'pie' ? `calc(50% - ${200 + (axisLabelLength / 2 * 10)}px` : '',
    }),
    chartTitle: {
        textAlign: 'center',
        fontSize: theme.spacing(2.5),
        margin: theme.spacing(0, -1, 1.5, -1),
        borderBottom: '1px solid #ddd',
        padding: theme.spacing(1)
    },
    yAxisLabels: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: theme.spacing(2),
    },
    xAxisLabels: {
        textAlign: 'center',
        fontSize: theme.spacing(2),
    }
}));

export const ChatbotChartCard = forwardRef(({ chartType, ...rest }, ref) => {
    const chartData = rest?.chartData?.[chartType]?.data
    const {
        chartTitle = "",
        xTitle = "",
        yMajorTitle = "",
        yMinorTitle = ""
    } = rest?.chartData?.[chartType] || {};

    let axisLabelLength = 0;
    axisLabelLength = chartData?.reduce((max, item) => {
        return Math.max(item?.[rest?.xKey].length, max)
    }, 0)
    const classes = useStyles({ chartType, axisLabelLength });

    const chartProps = {
        ...rest,
        width: 200,
        height: 200,
        margins: { top: 20, right: 20, bottom: 20, left: 50 },
        labels: true,
        legend: !['line', 'combo'].includes(chartType),
        trendline: true,
        themeType: "light",
        hideTopText: false,
        showLineLabel: true,
        showBarLabel: chartType != "combo",
        data: chartData,
        maxLabelLength: 100,
        rotateLabel: false
    }
    const isHorizontal = chartData?.length > 5;
    const barChartProps = {
        showBarLabel: false,
        horizontal: isHorizontal,
        height: isHorizontal ? chartData?.length * 30 : chartProps.height,
        margins: isHorizontal ? { ...chartProps.margins, left: (axisLabelLength * 7 + 10) } : chartProps.margins,
    }

    const comboChartProps = {
        ...barChartProps,
        showBarLabel: false,
    }

    const pieChartProps = {
        ...chartProps,
        margins: null,
        textColor: "black",
        suffix: '%',
        colorSet: 'lisaChartColors'
    }

    const lineChartProps = {
        ...chartProps,
        height: 250,
        margins: { ...chartProps.margins, bottom: 60 },
    }

    return chartType && (
        <div id={rest?.id} ref={ref} data-testid={rest?.id} className={classes.root} >
            <div className={`${classes.chartTitle}  chart-title`}>
                {chartTitle}
            </div>
            <div className={`${classes.yAxisLabels} axis-title`} >
                <span>{isHorizontal && ['bar', 'combo'].includes(chartType) ? xTitle : yMajorTitle}</span>
                <span>{yMinorTitle}</span>
            </div>
            {chartType === 'bar' && <BarChart wrapit {...chartProps} {...barChartProps} />}
            {chartType === 'pie' && <PieChart {...chartProps} {...pieChartProps} />}
            {chartType === 'line' && <LineChart {...chartProps} {...lineChartProps} />}
            {chartType === 'combo' && <TrendLineChart {...chartProps} {...comboChartProps} />}
            <div className={`${classes.xAxisLabels} axis-title`}  >
                <span>{isHorizontal && ['bar', 'combo'].includes(chartType) ? yMajorTitle : xTitle}</span>
            </div>
        </div>
    )
})